// src/utils/deliveryDates.ts
import { supabase } from '../services/supabase';

export interface Location {
    country_code: string;
}

export const getUserLocation = async (userId: string): Promise<Location | null> => {
    if (!userId) {
        console.warn('getUserLocation called without userId');
        return null;
    }

    try {
        const { data, error } = await supabase
            .from('customers')
            .select('country_code')  // Только country_code
            .eq('id', userId)
            .maybeSingle();

        if (error) {
            console.error('Error fetching user location:', error);
            return null;
        }

        if (!data) {
            console.log('No location data found for user:', userId);
            return null;
        }

        console.log('User country fetched:', data.country_code);
        return { country_code: data.country_code };
    } catch (error) {
        console.error('Error in getUserLocation:', error);
        return null;
    }
};

export const calculateDeliveryDate = async (
    isPickup: boolean = false,
    location?: Location
): Promise<{ date: Date; shortText: string; fullText: string }> => {
    const now = new Date();
    const deliveryDate = new Date(now);

    if (isPickup) {
        // Самовывоз - сегодня или завтра
        if (now.getHours() < 18) {
            deliveryDate.setDate(now.getDate());
        } else {
            deliveryDate.setDate(now.getDate() + 1);
        }
    } else {
        // Доставка - от 1 до 5 дней в зависимости от страны
        let daysToAdd = 3; // по умолчанию

        if (location?.country_code) {
            switch (location.country_code) {
                case 'TJ':
                    daysToAdd = 2; // Таджикистан - 2 дня
                    break;
                case 'RU':
                    daysToAdd = 5; // Россия - 5 дней
                    break;
                case 'KZ':
                    daysToAdd = 4; // Казахстан - 4 дня
                    break;
                case 'UZ':
                    daysToAdd = 3; // Узбекистан - 3 дня
                    break;
                case 'KG':
                    daysToAdd = 3; // Кыргызстан - 3 дня
                    break;
                default:
                    daysToAdd = 7; // другие страны - 7 дней
            }
        }

        deliveryDate.setDate(now.getDate() + daysToAdd);
    }

    const shortText = deliveryDate.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long'
    });

    const fullText = deliveryDate.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });

    return { date: deliveryDate, shortText, fullText };
};

export const getDefaultDeliveryText = (isPickup: boolean = false): string => {
    if (isPickup) {
        return 'сегодня после 18:00';
    }
    return '3-5 дней';
};